import React from 'react'
import AddressSearchDialogContent from '../../routes/address/AddressSearchDialogContent'
import { PAGE_CLASSES } from '../../routes/pageClasses.constants'
import Page from '../genericComponents/Page'
import Header from '../header/Header'
import Main from '../main/Main'
import Map from '../map/Map'
import SearchDialog from '../search/SearchDialog'
import AddressSuggestContent from '../suggest/AddressSuggestContent'
import MapQuizHandler from './MapQuizHandler'
import QuizCitiesMainContent from './QuizCitiesMainContent'
import QuizCitiesMetaManager from './QuizCitiesMetaManager'
import QuizGuessMarker from './QuizGuessMarker'
import QuizHeader from './QuizHeader'
import QuizResultMarker from './QuizResultMarker'

export const renderPage = () => {
  const { SearchHomePage, withToaster } = PAGE_CLASSES

  return (
    <Page cssClasses={[SearchHomePage, withToaster]} key="Page">
      <QuizCitiesMetaManager />
      <Map key="Map">
        <MapQuizHandler />
        <QuizGuessMarker />
        <QuizResultMarker />
      </Map>
      <Header key="Header">
        <QuizHeader />
      </Header>
      <SearchDialog key="SearchDialog" suggestContent={<AddressSuggestContent />}>
        <AddressSearchDialogContent />
      </SearchDialog>
      <Main key="Main" withoutSubHeader>
        <QuizCitiesMainContent />
      </Main>
    </Page>
  )
}
